import { useEffect, useState } from 'react';
import { Edit, SaveButton, SelectArrayInput, SimpleForm, TextInput, Toolbar, useDataProvider } from 'react-admin';

interface RoleChoice {
  id: string;
  name: string;
}

const CustomToolbar = () => (
  <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
    <SaveButton />
  </Toolbar>
);

const DashboardEdit = () => {
  const [roleChoices, setRoleChoices] = useState<RoleChoice[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const dataProvider = useDataProvider();

  useEffect(() => {
    dataProvider
      .getList('predefined-permission-roles', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'id', order: 'ASC' },
        filter: {}
      })
      .then(({ data }) =>
        setRoleChoices(
          data.map((role) => ({
            id: role.name,
            name: role.name
          }))
        )
      )
      .then(() => setIsLoading(false));
  }, [dataProvider]);

  return (
    <Edit mutationMode="pessimistic">
      <SimpleForm toolbar={<CustomToolbar />}>
        <TextInput disabled source="uuid" />
        <TextInput disabled source="name" />
        <SelectArrayInput source="allowedRoles" choices={roleChoices} disabled={isLoading} helperText={isLoading ? 'Loading roles...' : 'Select roles that can manage this dashboard (leave empty to allow all roles)'} />
      </SimpleForm>
    </Edit>
  );
};

export default DashboardEdit;
